import moment from 'moment';
import { sortData } from '../BasicMobileGrid.utils';

const runValidationCheck = ({ filterData = {}, value }) => {
  const type = filterData.type;
  const filterType = filterData.filterType;
  const rowDataToCheck = value || '';
  // If Text/FuzzyFilter Type
  if (type === 'contains' && filterType === 'text') {
    // TODO: possibly add a UI control to toggle whether filter is case-sensitive
    const filterValue = String(filterData.filter)?.toLowerCase()?.trim();
    const rowValue = String(rowDataToCheck)?.toLowerCase()?.trim();
    if (filterData.variant === 'fuzzy') {
      if (rowValue?.includes(filterValue)) return true;
    }
    if (rowValue === filterValue) return true;
    return false;
  }
  // If Number Type
  if (filterType === 'number') {
    if (type === 'equals') {
      if (Number(rowDataToCheck) === Number(filterData.filter)) return true;
      return false;
    }
    if (type === 'greaterThan') {
      if (Number(rowDataToCheck) > Number(filterData.filter)) return true;
      return false;
    }
    if (type === 'lessThan') {
      if (Number(rowDataToCheck) < Number(filterData.filter)) return true;
      return false;
    }
  }
  // If Date Type
  if (filterType === 'date') {
    const inclusiveOrExclusive = filterData.inRangeInclusive ? '[]' : '()';
    const isBetween = moment(rowDataToCheck).isBetween(
      filterData.dateFrom,
      filterData.dateTo,
      'day',
      inclusiveOrExclusive
    );
    if (isBetween) return true;
    return false;
  }
  // If the filterType is unknown just skip it and let the data through
  return true;
};

/** Used to apply filters from FilterPanel/filterState */
export default function getFilteredRows({
  columnState,
  filterState,
  formattedColumnDefs,
  page,
  pageSize,
  rows: unsortedRows,
  sortState
}) {
  // If there is a sortState then we need to sort the rows before filtering
  const rows = sortData({
    sortState,
    // TODO: Maybe this could just use columnState instead
    columnDefs: formattedColumnDefs,
    rows: unsortedRows
  });
  // Array of filters needing to be ran
  const filters = Object.values(filterState || {});
  // If no filters then return data;
  if (filters.length === 0) {
    const paginatedRows = rows.slice(0, page * pageSize);
    return { paginatedData: paginatedRows, totalRows: rows?.length };
  }
  const newData = rows.filter((row) => {
    // Check if it pass all set filters
    let rowPassesAllFilters = true;
    for (let i = 0; i < filters.length; i += 1) {
      // NOTE: Filters can have an OR | AND operator that changes how filtering behaves
      const filter = filters[i] || {};
      const { field, filterData, operator } = filter;
      // Get filterValueFormatter for column if defined
      const column = columnState.find((col) => col?.field === field) || {};
      const getValue = column.filterValueGetter
        ? column.filterValueGetter
        : ({ data }) => data[field];
      // If operator filter is OR then check if any field filters are true
      if (operator === 'OR') {
        // Only check against filters with the same field (status is Approved OR status is Rejected)
        // Check each of these conditions are false before filtering them out
        const currentFieldFilters = filters.filter((filter) => filter.field === field);
        let shouldPass = false;
        for (let k = 0; k < currentFieldFilters.length; k += 1) {
          const orFieldFilter = currentFieldFilters[k] || {};
          const orFieldFilterData = orFieldFilter.filterData;
          const orColumn = columnState.find((col) => col?.field === field) || {};
          const getOrValue = orColumn.filterValueGetter
            ? orColumn.filterValueGetter
            : ({ data }) => data[orFieldFilter.field];
          if (
            runValidationCheck({
              filterData: orFieldFilterData,
              value: getOrValue({ data: row })
            })
          ) {
            shouldPass = true;
          }
        }
        // Set this row to pass based on the result of the OR logic
        if (!shouldPass) rowPassesAllFilters = false;
      }
      if (operator === 'AND') {
        // Only apply and condition to the same field. (amount is greater than 0 AND amount is less than 100)
        // Check that each of these conditions are true before allowing the row through the filter
        const allFieldFilters = filters.filter((filter) => filter.field === field);
        let shouldPass = true;
        for (let j = 0; j < allFieldFilters.length; j += 1) {
          const andFieldFilter = allFieldFilters[j] || {};
          const andFieldFilterData = andFieldFilter.filterData;
          const andColumn = columnState.find((col) => col?.field === field) || {};
          const getAndValue = andColumn.filterValueGetter
            ? andColumn.filterValueGetter
            : ({ data }) => data[andFieldFilter.field];
          if (
            !runValidationCheck({
              filterData: andFieldFilterData,
              value: getAndValue({ data: row })
            })
          )
            shouldPass = false;
        }
        // Set this row to pass based on the result of the AND logic
        if (!shouldPass) rowPassesAllFilters = false;
      }
      // Do Basic Thing
      if (operator !== 'OR' && operator !== 'AND') {
        // If row doesn't pass a basic filter then set to false
        if (!runValidationCheck({ filterData, value: getValue({ data: row }) }))
          rowPassesAllFilters = false;
      }
    }
    return rowPassesAllFilters;
  });

  // NOTE: Take all beginning data up to whatever the max is from pages/pageSize
  const paginatedData = newData.slice(0, page * pageSize);
  return { paginatedData, totalRows: newData?.length };
}

// {
//   field: 'status',
//   nameDisplay: 'Status',
//   criteriaDisplay: 'Requires My Approval',
//   id: 'status-multi-Requires my Approval',
//   operator: 'OR',
//   filterData: {
//     type: 'contains',
//     filter: 'Requires my approval',
//     filterType: 'text',
//   },
// },
// {
//   field: 'status',
//   nameDisplay: 'Status',
//   criteriaDisplay: 'Requires my approval Reversal',
//   id: 'status-multi-Requires my approval Reversal',
//   operator: 'OR',
//   filterData: {
//     type: 'contains',
//     filter: 'Requires my approval Reversal',
//     filterType: 'text',
//   },
// },
// {
//   field: 'status',
//   nameDisplay: 'Status',
//   criteriaDisplay: 'Stale dated',
//   id: 'status-multi-Stale dated',
//   operator: 'OR',
//   filterData: {
//     type: 'contains',
//     filter: 'Stale dated',
//     filterType: 'text',
//   },
// },

// {
//   field: "activated",
//   nameDisplay: "Activated",
//   criteriaDisplay: "2020-11-10 to 2020-11-30",
//   id: "activated-inRange-2020-11-10 to 2020-11-30",
//   filterData: {
//     dateFrom: "2020-11-10",
//     dateTo: "2020-11-30",
//     format: "YYYY-MM-DD",
//     type: "inRange",
//     filterType: "date",
//     inRangeInclusive: "true",
//   },
// },
